module.exports = __webpack_public_path__ + "media/images/lp-fukushima12/homes_yumoto_b-e35cfe3d9ac21eb49bcf184ba69e9005.jpg";